import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicPopovers, HurryUps } from "../../../../Constant";
import { BASIC_POPOVER_DATA, BASIC_POPOVER_LIST } from "../../../../Data/UiKit/Popover";
import CommonPopover from "../Common/CommonPopover";
import { Btn } from "../../../../AbstractElements";
import Popovers from "../../../../CommonElements/Popover";
import { useState } from "react";

const BasicPopover = () => {
  const [basicPopover, setBasicPopover] = useState(false);
  const basicToggle = () => setBasicPopover(!basicPopover);
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BasicPopovers} span={BASIC_POPOVER_DATA} />
        <CardBody className="common-flex popover-wrapper">
          <Btn id="Popover-1" color="primary" className="example-popover mb-0 me-0" onClick={basicToggle}>{HurryUps}</Btn>
          <Popovers isOpen={basicPopover} placement="top" target="Popover-1" trigger="click" title="Basic Popover">
            If the package restore doesn't help, you can look at the Output window in the Visual Studio.
          </Popovers>
          {BASIC_POPOVER_LIST.map((data) => (
            <CommonPopover key={data.id} item={data} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicPopover;
